import React from "react";

interface CalculatedFieldProps {
  id: string;
  label: string;
  value: number;
  prefix?: string; // e.g. "£"
  suffix?: string; // e.g. "kWh"
  decimals?: number;
  note?: string; // e.g. explains why the figure has been scaled
}

const CalculatedField: React.FC<CalculatedFieldProps> = ({
  id,
  label,
  value,
  prefix = "",
  suffix = "",
  decimals = 2,
  note,
}) => {
  const displayValue = `${prefix}${value.toFixed(decimals)}${suffix ? ` ${suffix}` : ""}`;

  return (
    <div className="calculated-field">
      <label htmlFor={id}>{label}</label>
      <input
        id={id}
        type="text"
        value={displayValue}
        disabled
        readOnly
        className="calculated-field__input"
        aria-label={`${label} (calculated)`}
      />
      {note && <span className="calculated-field__note">{note}</span>}
    </div>
  );
};

export default CalculatedField;
